<script>
export default {
  name: "CheckBox",
  props: {
    name: {
      type: String,
      default: undefined
    },
    value: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:value"]
};
</script>

<template>
  <div class="custom-checkbox">
    <label class="custom-checkbox__label">
      <input
        :checked="value"
        :name="name"
        class="custom-checkbox__input"
        :class="{ 'custom-checkbox__input--secondary': secondary }"
        type="checkbox"
        @change="$emit('update:value', $event.target.checked)"
      />
      <svg
        class="custom-checkbox__checkmark"
        width="14"
        height="10"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M1.56 4.2l4.15 4.24 6.85-7"
          stroke-width="2"
          fill="none"
          fill-rule="evenodd"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div>
        <slot />
      </div>
    </label>
  </div>
</template>
